import Swiper, { Navigation, Thumbs, Pagination, Lazy, Autoplay } from 'swiper';

Swiper.use([Navigation, Thumbs, Pagination, Lazy, Autoplay]);

function thumbsGallery(gallery) {
  const glrMain = gallery.querySelector('.img-gallery__main');
  const glrThumb = gallery.querySelector('.img-gallery__thumbs');

  const swThumb = new Swiper(glrThumb, {
    spaceBetween: 8,
    slidesPerView: 'auto',
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    preloadImages: false,
    lazy: true,
  });

  gallery.inst = new Swiper(glrMain, {
    spaceBetween: 16,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    preloadImages: false,
    lazy: true,
    thumbs: { swiper: swThumb },
  });
}

function slideGallery(gallery) {
  const glr = gallery.querySelector('.swiper-container');

  gallery.inst = new Swiper(glr, {
    spaceBetween: 10,
    slidesPerView: 'auto',
    preloadImages: false,
    navigation: {
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next',
    },
    breakpoints: {
      768: { spaceBetween: 16 },
    },
  });
}

/* function cardsSwiper(slider) {
  const anim = Boolean(slider.getAttribute('data-anim'));
  // const loop = Boolean(slider.getAttribute('data-loop'));
  // const minSlidesForAutoplay = slider.classList.contains('m-companies-slider') ? 5 : 4;
  // const slides = slider.querySelectorAll('.swiper-slide');
  const prev = slider.querySelector('.m-cards-slider__nav--prev');
  const next = slider.querySelector('.m-cards-slider__nav--next');
  let autoplay = false;
  if (anim) {
    autoplay = {
      delay: 3000,
      // pauseOnMouseEnter: true,
      // disableOnInteraction: false,
    };
  }
  const animOpts = {
    autoplay,
    // loop,
    // loopedSlides: 5,
    navigation: prev || next ? { prevEl: prev, nextEl: next } : false,
  };

  slider.inst = new Swiper(slider, {
    slidesPerView: 'auto',
    ...animOpts,
  });

  slider.addEventListener('mouseenter', () => {
    slider.inst.autoplay.stop();
  });
  slider.addEventListener('mouseleave', () => {
    slider.inst.autoplay.start();
  });
} */

function cardsSwiper(slider) {
  const paging = slider.closest('.swiper-sect')?.querySelector('.swiper-sect__pagination');
  const anim = Boolean(slider.getAttribute('data-anim'));
  const speed = Number(slider.getAttribute('data-speed')) || 3000;
  // const minSlidesForAutoplay = slider.classList.contains('m-companies-slider') ? 5 : 4;
  // const slides = slider.querySelectorAll('.swiper-slide');
  const prev = slider.querySelector(
    '.m-cards-slider__nav--prev, .cphi-cards-slider__nav--prev .cphi-cards-slider__btn',
  );
  const next = slider.querySelector(
    '.m-cards-slider__nav--next, .cphi-cards-slider__nav--next .cphi-cards-slider__btn',
  );

  let pagination = false;
  let breakpoints = null;
  if (paging) {
    pagination = {
      el: paging,
      clickable: true,
    };

    breakpoints = {
      768: {
        slidesPerGroup: 3,
      },
      992: {
        slidesPerGroup: 4,
      },
      1200: {
        slidesPerGroup: 5,
      },
    };
  }

  console.log('speed', speed);

  let autoplay = false;
  if (anim) {
    autoplay = {
      delay: speed,
      // pauseOnMouseEnter: true,
      // disableOnInteraction: false,
    };
  }
  const animOpts = {
    pagination,
    breakpoints,
    autoplay,
    // loop,
    // loopedSlides: 5,
    navigation: prev || next ? { prevEl: prev, nextEl: next } : false,
  };

  slider.inst = new Swiper(slider, {
    slidesPerView: 'auto',
    // slidesPerGroupAuto: true,
    ...animOpts,
  });

  slider.addEventListener('mouseover', () => {
    slider.inst.autoplay.stop();
  });
  slider.addEventListener('mouseleave', () => {
    slider.inst.autoplay.start();
  });
}

function fullWidthSlides(slider) {
  const elPagination = slider.querySelector('.swiper-pagination');
  const delayAttr = Number(slider.getAttribute('data-delay'));

  slider.inst = new Swiper(slider, {
    loop: true,
    pagination: {
      el: elPagination,
    },
    autoplay: {
      delay: delayAttr || 3000,
      pauseOnMouseEnter: true,
      disableOnInteraction: false,
    },
  });
}

export default function swiperGalleries(galleries) {
  galleries.forEach((gallery) => {
    if (gallery.classList.contains('swiper-initialized')) return;

    if (gallery.classList.contains('img-gallery')) {
      thumbsGallery(gallery);
    } else if (gallery.classList.contains('c-img-slider')) {
      slideGallery(gallery);
    } else if (gallery.classList.contains('swipe-cards')) {
      cardsSwiper(gallery);
    } else if (gallery.classList.contains('swiper--fw')) {
      fullWidthSlides(gallery);
    }
  });
}
